export const HEALTH_ENDPOINT = '/health.txt';
const TIMEOUT_MS = 5000;

export const fetchNetworkProbe = async (): Promise<boolean> => {
  try {
    const response = await fetch(HEALTH_ENDPOINT, {
      method: 'HEAD',
      cache: 'no-store',
      signal: AbortSignal.timeout(TIMEOUT_MS),
    });
    return response.ok;
  } catch {
    return false;
  }
};
